import React, { useState, useEffect } from "react";

const DistanceCalculator = ({ targetCoordinates, onDistanceCalculated }) => {
  const [distance, setDistance] = useState(null);
  const [error, setError] = useState(null);

  const calculateDistance = (currentCoordinates, targetCoordinates) => {
    const { latitude: lat1, longitude: lon1 } = currentCoordinates;
    const [lat2, lon2] = targetCoordinates;

    const toRadians = (deg) => deg * (Math.PI / 180);
    const R = 6371; // Radius of the Earth in km

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  };

  const handleGetDistance = () => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const currentCoordinates = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        const calculatedDistance = calculateDistance(currentCoordinates, targetCoordinates);
        setDistance(calculatedDistance.toFixed(2));
        if (onDistanceCalculated) onDistanceCalculated(calculatedDistance.toFixed(2));
      },
      (err) => {
        setError("Unable to retrieve your location.");
        setDistance(null); // Reset distance in case of error
      }
    );
  };

  useEffect(() => {
    handleGetDistance();
  }, [targetCoordinates]);

  return (
    <div>
      {error ? (
        <span>{error}</span>
      ) : distance && !isNaN(distance) ? (
        <span>{distance} km</span>
      ) : (
        <span>Not available</span>
      )}
    </div>
  );
};

export default DistanceCalculator;
